if (!customElements.get('featured-collections-tabs')) {
  class FeaturedCollectionsTabs extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('tabs:change', this._onTabsChange.bind(this), { signal: this.controller.signal });
      this.addEventListener('tabs:panel-loaded', this._onPanelLoaded.bind(this), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    _onPanelLoaded(event) {
      const panel = event.detail?.panel;
      if (panel && !panel.hidden) this._syncSlider(panel);
    }

    _onTabsChange(event) {
      const panelId = event.detail?.panelId;
      if (!panelId) return;

      this._syncSlider(this.querySelector(`#${panelId}`));
    }

    _syncSlider(panel) {
      const slider = panel?.querySelector('theme-slider');
      if (!slider) return;

      requestAnimationFrame(() => {
        if (typeof slider.setUpSlider === 'function') slider.setUpSlider();
      });

      this.querySelectorAll('.featured-collections-tabs__nav').forEach((navArrows) => {
        if (typeof navArrows.setTarget === 'function') navArrows.setTarget(slider.id);
      });
    }
  }

  customElements.define('featured-collections-tabs', FeaturedCollectionsTabs);
}
